// Shared pure helpers used by App.js and extracted modal components.

export function parseServicePackageFeatures(raw) {
  if (raw == null || raw === '') return [];
  if (typeof raw === 'object' && raw !== null && !Array.isArray(raw)) {
    const arr = raw.features;
    return Array.isArray(arr) ? arr : [];
  }
  if (typeof raw === 'string') {
    const t = raw.trim();
    if (t === '[object Object]' || t.startsWith('[object ')) return [];
    try {
      const parsed = JSON.parse(t);
      if (parsed && typeof parsed === 'object' && Array.isArray(parsed.features)) return parsed.features;
      if (Array.isArray(parsed)) return parsed;
    } catch {
      return [];
    }
  }
  return [];
}

export function buildRetailCompanyAddressString(company) {
  const parts = [company.street_address, company.city, company.province, company.postal_code, company.country]
    .map((s) => (s != null ? String(s).trim() : ''))
    .filter(Boolean);
  return parts.join(', ');
}

export function buildBuildingAddressString(building) {
  if (!building) return '';
  const existing = building.address != null ? String(building.address).trim() : '';
  if (existing) return existing;
  const street = [building.street_number, building.street_name]
    .map((s) => (s != null ? String(s).trim() : ''))
    .filter(Boolean)
    .join(' ');
  return [street, building.city, building.postal_code, building.country]
    .map((s) => (s != null ? String(s).trim() : ''))
    .filter(Boolean)
    .join(', ');
}
